import React from 'react';
import CreateDashboardIcon from '../.././components/css/dark/img/theme-images/create-dashboard.svg';
import userIcon from '../.././components/css/dark/img/theme-images/group_icon.svg';
import emailIcon from '../.././components/css/dark/img/theme-images/mail.svg';
import profileIcon from '../.././components/css/dark/img/theme-images/profile_icon.svg';
import exportIcon from '../.././components/css/dark/img/theme-images/export.svg';
import $ from 'jquery';
import Pagination from "react-js-pagination";
import { userService } from '../../_services';

class Popup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
            error: '',
            loader: true,
            activePage: 1,
            UserList: [],
            UserList_Temp: [],
            mainAPIresult: [],
            disableImage: true,
            currentPaging: 1,
            activeState: false,
            whSearchText: '',
            cDashboardActivePagin: false,
            Data_Not_Found: '',
            tabselected: 'Active',
            TerminatedList: [],
            TerminatedList_Temp: [],
            t_MainAPIresult: [],
            columnData: []
        };
    }
    componentDidMount() {
        this.fetchTerminatedList(this.state.userdata.id, this.state.userdata.wholesaler);
        this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole);
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
        $(window).resize(function () {
            var inactiveHeight = $('#inactive_reps').height();
            if (inactiveHeight < 310) {
                $('.manage-distributor-design .header').addClass('haveScroll');
            } else {
                $('.manage-distributor-design .header').removeClass('haveScroll');
            }
        });
    }
    ExportDistributorData = (event) => {
        try {
            let widgetTitle = '';
            var data = "";
            var tableData = [];
            let whid = $(event.target).attr('data-id');
            let whname = $(event.target).attr('data-name');
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
                body: JSON.stringify({ whid, whname })
            };
            return fetch(`/api/admin/Downlaod_Distributor_Data`, requestOptions)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return this.handleResponse(response);
                })
                .then(apidata => {
                    try {
                        if (!apidata || apidata.length === 0) {
                            alert('No data available to export');
                            return;
                        }
                        
                        // Add CSV headers
                        tableData.push("First Name,Last Name,Email,Commission");
                        
                        for (var j = 0; j < apidata.length; j++) {
                            try {
                                var rowData = [];
                                rowData.push(apidata[j].firstName || "");
                                rowData.push(apidata[j].lastName || "");
                                rowData.push(apidata[j].emailId || "");
                                rowData.push(apidata[j].commission || "");
                            }
                            catch (error) {
                                rowData.push("", "", "", "");
                            }
                            tableData.push(rowData.join(","));
                        }
                        data += tableData.join("\n");
                        if (window.navigator.msSaveOrOpenBlob) {
                            // IE11
                            window.navigator.msSaveOrOpenBlob(new Blob([data]), "Distributor List.csv");
                        } else {
                            // Modern browsers
                            const blob = new Blob([data], { type: "text/csv" });
                            const url = URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.id = 'download-link';
                            link.download = "Distributor List.csv";
                            link.href = url;
                            document.body.appendChild(link);

                            // Ensure DOM is ready, then click
                            setTimeout(() => {
                                link.click();
                                document.body.removeChild(link);
                                URL.revokeObjectURL(url); // Clean up memory
                            }, 0);
                        }
                    }
                    catch (error) {
                        alert('Error processing data: ' + error.message);
                    }
                })
                .catch(error => {
                    alert('Check internet connection. Unable to download distributor data.');
                    console.error('Export error:', error);
                });

        } catch (error) {
            alert('An error occurred: ' + error.message);
        }
    }
    ExportGroupNumberData = (event) => {
        try {
            let widgetTitle = '';
            var data = "";
            var tableData = [];
            let whid = $(event.target).attr('data-id');
            let whname = $(event.target).attr('data-name');
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
                body: JSON.stringify({ whid, whname })
            };
            return fetch(`/api/admin/Downlaod_GroupNumber_Data`, requestOptions)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return this.handleResponse(response);
                })
                .then(apidata => {
                    try {
                        if (!apidata || apidata.length === 0) {
                            alert('No data available to export');
                            return;
                        }
                        
                        // Add CSV headers
                        tableData.push("Group Number,Commission,Termination Date");
                        
                        for (var j = 0; j < apidata.length; j++) {
                            try {
                                var rowData = [];
                                rowData.push(apidata[j].groupNumber || "");
                                rowData.push(apidata[j].commission || "");
                                rowData.push(apidata[j].terminationDate || "");
                            }
                            catch (error) {
                                rowData.push("", "", "");
                            }
                            tableData.push(rowData.join(","));
                        }
                        data += tableData.join("\n");
                        if (window.navigator.msSaveOrOpenBlob) {
                            // IE11
                            window.navigator.msSaveOrOpenBlob(new Blob([data]), "GroupNumber List.csv");
                        } else {
                            // Modern browsers
                            const blob = new Blob([data], { type: "text/csv" });
                            const url = URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.id = 'download-link';
                            link.download = "GroupNumber List.csv";
                            link.href = url;
                            document.body.appendChild(link);

                            // Ensure DOM is ready, then click
                            setTimeout(() => {
                                link.click();
                                document.body.removeChild(link);
                                URL.revokeObjectURL(url); // Clean up memory
                            }, 0);
                        }
                    }
                    catch (error) {
                        alert('Error processing data: ' + error.message);
                    }
                })
                .catch(error => {
                    alert('Check internet connection. Unable to download group number data.');
                    console.error('Export error:', error);
                });

        } catch (error) {
            alert('An error occurred: ' + error.message);
        }
    }
    fetchTerminatedList(whid, whname) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ whid, whname })
            };
            return fetch(`/api/admin/Terminated_WhList`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length <= 9)
                            this.setState({ TerminatedList: apidata, t_MainAPIresult: apidata, TerminatedList_Temp: apidata, loader: false, error: '' });
                        else {
                            let userlistobj = JSON.parse(JSON.stringify(apidata));
                            let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice(0, 9) : userlistobj;
                            this.setState({ TerminatedList: apidata, t_MainAPIresult: apidata, TerminatedList_Temp: usertemplistobj, loader: false, error: '' });
                        }
                        if (this.state.cDashboardActivePagin == true) {
                            this.terminatedPageChange(this.state.currentPaging);
                        }
                        if (this.props.backActivePagin > 1) {
                            this.terminatedPageChange(this.props.backActivePagin);
                        }
                        if (!userService.Check_Null_Empty(this.props.backSearch)) {
                            $('#TSearcInput').val(this.props.backSearch)
                            this.TFilterRecords();
                        }
                        if (!userService.Check_Null_Empty(this.state.whSearchText)) {
                            $('#TSearcInput').val(this.state.whSearchText)
                            this.TFilterRecords();
                        }
                        $(function () {
                            var inactiveHeight = $('#inactive_reps').height();
                            if (inactiveHeight < 310) {
                                $('.manage-distributor-design .header').addClass('haveScroll');
                            } else {
                                $('.manage-distributor-design .header').removeClass('haveScroll');
                            }
                        });
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    terminatedPageChange = (pageNumber) => {
        $("li").removeClass('active');
        if (this.props.backActivePagin > 1 && this.state.activeState == false) {
            let userlistobj = JSON.parse(JSON.stringify(this.state.TerminatedList));
            let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice((pageNumber - 1) * 9, 9) : userlistobj;
            this.setState({ activePage: this.props.backActivePagin, TerminatedList_Temp: usertemplistobj, loader: false, currentPaging: pageNumber, activeState: true, error: '' });
            $("a[aria-label='Go to page number " + this.props.backActivePagin + "']").parents("li").addClass('active');
        } else {
            let userlistobj = JSON.parse(JSON.stringify(this.state.TerminatedList));
            let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice((pageNumber - 1) * 9, 9) : userlistobj;
            this.setState({ activePage: pageNumber, TerminatedList_Temp: usertemplistobj, loader: false, currentPaging: pageNumber, error: '', cDashboardActivePagin: false });
            $("a[aria-label='Go to page number " + this.state.currentPaging + "']").parents("li").addClass('active');
        }
    }
    fetchDataLocally(roleName, roleType) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ roleName, roleType })
            };
            return fetch(`/api/admin/ManageWholesalerDetail`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length <= 9)
                            this.setState({ UserList: apidata, mainAPIresult: apidata, UserList_Temp: apidata, loader: false, error: '' });
                        else {
                            let userlistobj = JSON.parse(JSON.stringify(apidata));
                            let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice(0, 9) : userlistobj;
                            this.setState({ UserList: apidata, mainAPIresult: apidata, UserList_Temp: usertemplistobj, loader: false, error: '' });
                        }
                        if (this.state.cDashboardActivePagin == true) {
                            this.handlePageChange(this.state.currentPaging);
                        }
                        if (this.props.backActivePagin > 1) {
                            this.handlePageChange(this.props.backActivePagin);
                        }
                        if (!userService.Check_Null_Empty(this.props.backSearch)) {
                            $('#SearcInput').val(this.props.backSearch)
                            this.FilterRecords();
                        }
                        if (!userService.Check_Null_Empty(this.state.whSearchText)) {
                            $('#SearcInput').val(this.state.whSearchText)
                            this.FilterRecords();
                        }
                        $(function () {
                            var inactiveHeight = $('#inactive_reps').height();
                            if (inactiveHeight < 310) {
                                $('.manage-distributor-design .header').addClass('haveScroll');
                            } else {
                                $('.manage-distributor-design .header').removeClass('haveScroll');
                            }
                        });
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    createDashboard = (e) => {
        this.setState({ disableImage: false, error: '', loader: true, cDashboardActivePagin: true });
        $(e.target).css("opacity", 0.5);
        let wholesalerName = $(e.target).attr('data-name');
        let wholesalerId = $(e.target).attr('data-id');
        this.newDashboard(this.state.userdata.paramsname, this.state.userdata.userrole, wholesalerName, wholesalerId);
    }
    newDashboard(roleName, roleType, whName, whId) {
        debugger;
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ roleName, roleType, whName, whId })
            };
            return fetch(`/api/admin/CreateWhDashUser`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata[0].status_code == "1") {
                            this.setState({ error: apidata[0].status_message, loader: false });
                            setTimeout(() => {
                                this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole);
                                $('.create-dashboard').css("opacity", 1);
                            }, 1800)

                        } else {
                            this.setState({ error: apidata[0].status_message, loader: false });
                            this.setState({ disableImage: true });
                            $('.create-dashboard').css("opacity", 1);
                        }
                    }
                    catch (error) {
                        this.setState({ error: apidata[0].status_message, loader: false });
                        this.setState({ disableImage: true });
                        $('.create-dashboard').css("opacity", 1);
                    }
                });
        }
        catch (error) {
        }
    }
    handlePageChange = (pageNumber) => {
        $("li").removeClass('active');
        if (this.props.backActivePagin > 1 && this.state.activeState == false) {
            let userlistobj = JSON.parse(JSON.stringify(this.state.UserList));
            let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice((pageNumber - 1) * 9, 9) : userlistobj;
            this.setState({ activePage: this.props.backActivePagin, UserList_Temp: usertemplistobj, loader: false, currentPaging: pageNumber, activeState: true, error: '' });
            $("a[aria-label='Go to page number " + this.props.backActivePagin + "']").parents("li").addClass('active');
        } else {
            let userlistobj = JSON.parse(JSON.stringify(this.state.UserList));
            let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice((pageNumber - 1) * 9, 9) : userlistobj;
            this.setState({ activePage: pageNumber, UserList_Temp: usertemplistobj, loader: false, currentPaging: pageNumber, error: '', cDashboardActivePagin: false });
            $("a[aria-label='Go to page number " + this.state.currentPaging + "']").parents("li").addClass('active');
        }
    }
    FilterRecords = () => {
        let cPagin = parseInt($('.active a').text());
        let serachText = $('#SearcInput').val();
        if (serachText.length <= 0) return;
        let userlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function (e1) {
            return (e1.whName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.emailId.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.gnfix.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });
        let copyuserlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function (e1) {
            return (e1.whName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.emailId.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.gnfix.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });

        let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice(0, 9) : userlistobj;
        this.setState({ activePage: cPagin, UserList: copyuserlistobj, UserList_Temp: usertemplistobj, loader: false, error: '', whSearchText: serachText });
        if (cPagin > 1) {
            this.handlePageChange(cPagin);
        }
    }
    SearchOnKeyUp = () => {
        let serachText = $('#SearcInput').val();        
        let userlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function (e1) {
            return (e1.whName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.emailId.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.gnfix.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });
        let copyuserlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function (e1) {
            return (e1.whName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.emailId.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.gnfix.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });

        if (userlistobj.length == 0 || copyuserlistobj.length == 0) this.setState({ Data_Not_Found: 'No records found' });

        let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice(0, 9) : userlistobj;
        this.setState({ activePage: 1, UserList: copyuserlistobj, UserList_Temp: usertemplistobj, loader: false, error: '', whSearchText: serachText });
    }
    manageEmail = (e) => {
        let whSearch = $(e.target).attr('whsearch');
        let currentPagination = $(e.target).attr('currentpagination');
        let currentId = $(e.target).attr('data-id');
        let currentWholesaler = $(e.target).attr('data-name');
        let whId = $(e.target).attr('datawhid');
        this.props.manageEmailPopup(currentId, whId, currentWholesaler, currentPagination, whSearch);
        this.props.closePopup();
    }
    manageProfile = (e) => {
        let whSearch = $(e.target).attr('whsearch');
        let whIsrule = $(e.target).attr('data-isrule');
        let currentId = $(e.target).attr('data-id');
        let currentWholesaler = $(e.target).attr('data-name');
        let currentPagination = $(e.target).attr('currentpagination');
        this.props.manageGroupPopup(currentId, currentWholesaler, currentPagination, "1", whIsrule, whSearch);
        this.props.closePopup();
    }
    addWholesaler = (e) => {
        let currentPagination = $(e.target).attr('currentpagination');
        this.props.closeAddWholesalerPopup(currentPagination);
        this.props.closePopup();
    }
    editProfile = (e) => {
        let whSearch = $(e.target).attr('whsearch');
        let currentPagination = $(e.target).attr('currentpagination');
        let wholesalerName = $(e.target).attr('data-name');
        let wholesalerId = $(e.target).attr('data-id');
        let whprefix = $(e.target).attr('datawhprefix');
        this.props.closeEditProfilePopup(wholesalerName, wholesalerId, whprefix, currentPagination, whSearch);
        this.props.closePopup();
    }
    handletab = e => {

        let userlistobj_active = JSON.parse(JSON.stringify(this.state.UserList));
        let usertemplistobj_active = userlistobj_active.length > 9 ? userlistobj_active.splice(0, 9) : userlistobj_active;
       // this.setState({ UserList: apidata, mainAPIresult: apidata, UserList_Temp: usertemplistobj, loader: false, error: '' });

        let userlistobj = JSON.parse(JSON.stringify(this.state.TerminatedList));
        let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice(0, 9) : userlistobj;
        //this.setState({ activePage: pageNumber, TerminatedList_Temp: usertemplistobj, loader: false, currentPaging: pageNumber, error: '', cDashboardActivePagin: false });
        this.setState({ tabselected: e.currentTarget.getAttribute("data-id"), activePage: 1, currentPaging: 1, TerminatedList_Temp: usertemplistobj, UserList_Temp: usertemplistobj_active});
    }
    fetchTerminatedList(whid, whname) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ whid, whname })
            };
            return fetch(`/api/admin/Terminated_WhList`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length <= 9)
                            this.setState({ TerminatedList: apidata, t_MainAPIresult: apidata, TerminatedList_Temp: apidata, error: '' });
                        else {
                            let userlistobj = JSON.parse(JSON.stringify(apidata));
                            let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice(0, 9) : userlistobj;
                            this.setState({ TerminatedList: apidata, t_MainAPIresult: apidata, TerminatedList_Temp: usertemplistobj, error: '' });
                        }
                        if (this.state.cDashboardActivePagin == true) {
                            this.terminatedPageChange(this.state.currentPaging);
                        }
                        if (this.props.backActivePagin > 1) {
                            this.terminatedPageChange(this.props.backActivePagin);
                        }
                        if (!userService.Check_Null_Empty(this.props.backSearch)) {
                            $('#TSearcInput').val(this.props.backSearch)
                            this.TFilterRecords();
                        }
                        if (!userService.Check_Null_Empty(this.state.whSearchText)) {
                            $('#TSearcInput').val(this.state.whSearchText)
                            this.TFilterRecords();
                        }
                        $(function () {
                            var inactiveHeight = $('#inactive_reps').height();
                            if (inactiveHeight < 310) {
                                $('.manage-distributor-design .header').addClass('haveScroll');
                            } else {
                                $('.manage-distributor-design .header').removeClass('haveScroll');
                            }
                        });
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    terminatedPageChange = (pageNumber) => {
        $("li").removeClass('active');
        if (this.props.backActivePagin > 1 && this.state.activeState == false) {
            let userlistobj = JSON.parse(JSON.stringify(this.state.TerminatedList));
            let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice((pageNumber - 1) * 9, 9) : userlistobj;
            this.setState({ activePage: this.props.backActivePagin, TerminatedList_Temp: usertemplistobj, loader: false, currentPaging: pageNumber, activeState: true, error: '' });
            $("a[aria-label='Go to page number " + this.props.backActivePagin + "']").parents("li").addClass('active');
        } else {
            let userlistobj = JSON.parse(JSON.stringify(this.state.TerminatedList));
            let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice((pageNumber - 1) * 9, 9) : userlistobj;
            this.setState({ activePage: pageNumber, TerminatedList_Temp: usertemplistobj, loader: false, currentPaging: pageNumber, error: '', cDashboardActivePagin: false });
            $("a[aria-label='Go to page number " + this.state.currentPaging + "']").parents("li").addClass('active');
        }
    }
    TSearchOnKeyUp = () => {
        let serachText = $('#TSearcInput').val();
        let userlistobj = JSON.parse(JSON.stringify(this.state.t_MainAPIresult)).filter(function (e1) {
            return (e1.whName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.emailId.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.gnfix.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });
        let copyuserlistobj = JSON.parse(JSON.stringify(this.state.t_MainAPIresult)).filter(function (e1) {
            return (e1.whName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.emailId.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.gnfix.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });

        if (userlistobj.length == 0 || copyuserlistobj.length == 0) this.setState({ Data_Not_Found: 'No records found' });

        let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice(0, 9) : userlistobj;
        this.setState({ activePage: 1, TerminatedList: copyuserlistobj, TerminatedList_Temp: usertemplistobj, loader: false, error: '', whSearchText: serachText });
    }
    TFilterRecords = () => {
        let cPagin = parseInt($('.active a').text());
        let serachText = $('#TSearcInput').val();
        if (serachText.length <= 0) return;
        let userlistobj = JSON.parse(JSON.stringify(this.state.t_MainAPIresult)).filter(function (e1) {
            return (e1.whName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.emailId.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.gnfix.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });
        let copyuserlistobj = JSON.parse(JSON.stringify(this.state.t_MainAPIresult)).filter(function (e1) {
            return (e1.whName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.emailId.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.gnfix.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });

        let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice(0, 9) : userlistobj;
        this.setState({ activePage: cPagin, TerminatedList: copyuserlistobj, TerminatedList_Temp: usertemplistobj, loader: false, error: '', whSearchText: serachText });
        if (cPagin > 1) {
            this.terminatedPageChange(cPagin);
        }
    }
    render() {
        const { error } = this.state
        let disabled = false;
        disabled = this.state.loader ? true : false;
        return (
            <div>
                <div className='popup mfp-zoom-in manage-scroll manage-distributor-design admin-wh-section'>
                    <div className='popup_inner'>
                        <h1>{this.props.text}<button onClick={this.props.closePopup}>X</button></h1>

                        {
                            this.state.loader ? (<div className="theme-loader m-wholesaler"></div>) : null
                        }
                        <button className="btn add-wholesaler" disabled={disabled} currentpagination={this.state.currentPaging} onClick={this.addWholesaler}>Add Wholesaler</button>

                        <div className="searchSection populate">
                            <form autoComplete="off" onSubmit={e => { e.preventDefault() }}>
                                <div className="autocomplete">
                                    {
                                        this.state.tabselected == "Active" ? <input id="SearcInput" type="text" name="PhCityInput" scroll-id="CITY" disabled={disabled} data-id="dynamic" placeholder="Search" onKeyUp={this.SearchOnKeyUp} className="form-control searchTable searchtextarea" /> :
                                            <input id="TSearcInput" type="text" name="TPhCityInput" scroll-id="TCITY" data-id="Tdynamic" placeholder="Search" onKeyUp={this.TSearchOnKeyUp} className="form-control searchTable searchtextarea" />
                                    }
                                </div>
                                <div className={this.state.tabselected == "Inactive" ? "tab less-gap" : "tab"}>
                                    <a href="javascript:;" className={this.state.tabselected == "Active" ? 'tab-link link1 active' : 'tab-link link1'} onClick={disabled ? null : this.handletab} data-id="Active">Active</a>
                                    <a href="javascript:;" className={this.state.tabselected == "Inactive" ? 'tab-link link2 active' : 'tab-link link2'} onClick={disabled ? null : this.handletab} data-id="Inactive">Terminated</a>
                                </div>

                            </form>
                        </div>
                        <div className="tabs-section">
                            {

                                this.state.tabselected == "Active" ?
                                    <div className="active-content">
                                        <div className="content-section">

                                            {
                                                this.state.UserList != null && this.state.UserList.length > 0 ?
                                                    <table>
                                                        <thead>
                                                            <tr className="header">
                                                                <th className="first-one">Name</th>
                                                                <th className="second-one">No. of Group Number</th>
                                                                <th className="third-one">Group Prefix</th>
                                                                <th className="fourth-one">Last Month Commission</th>
                                                                <th className="fifth-one">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id="inactive_reps">
                                                            {
                                                                this.state.UserList_Temp.map((e1, i1) => {
                                                                    return (
                                                                        <tr className="userDashData" key={i1}>
                                                                            <td className="first-one">
                                                                                {e1.whName}
                                                                            </td>
                                                                            <td className="second-one">
                                                                                {e1.groupCount}
                                                                            </td>
                                                                            <td className="third-one">
                                                                                {e1.gnfix}
                                                                            </td>
                                                                            <td className="fourth-one">
                                                                                {e1.whComm}
                                                                            </td>
                                                                            <td className="fifth-one">
                                                                                {
                                                                                    parseInt(e1.dashBoardId) == 0 ?
                                                                                        <div>
                                                                                            <a href="javascript:void('0')" className="custom-tooltip"><img onClick={this.manageProfile} data-isrule={e1.isRuleBased} whsearch={this.state.whSearchText} currentpagination={this.state.currentPaging} data-id={e1.whId} data-name={e1.whName} src={userIcon} className="manage-profile" alt="group number" /><span className="hover-tooltip group-number">Group Number</span></a>
                                                                                            <a href="javascript:void('0')" className="custom-tooltip"><img data-id={e1.whId} data-name={e1.whName} whsearch={this.state.whSearchText} currentpagination={this.state.currentPaging} onClick={this.state.disableImage ? this.createDashboard : null} src={CreateDashboardIcon} className="create-dashboard" alt="Create Dashboard" /><span className="hover-tooltip create-dashboard">Create Dashboard</span></a>
                                                                                            <a href="javascript:void('0')" className="custom-tooltip"><img onClick={this.editProfile} whsearch={this.state.whSearchText} currentpagination={this.state.currentPaging} datawhprefix={e1.gnfix} data-comm={e1.whComm} data-id={e1.whId} data-name={e1.whName} src={profileIcon} className="profile-icon" alt="Manage Profile & Rules" /><span className="hover-tooltip manage-profile">Manage Profile & Rules</span></a>
                                                                                        </div>
                                                                                        :
                                                                                        <div>
                                                                                            <a href="javascript:void('0')" className="custom-tooltip"><img onClick={this.manageProfile} data-isrule={e1.isRuleBased} whsearch={this.state.whSearchText} currentpagination={this.state.currentPaging} data-id={e1.whId} data-name={e1.whName} src={userIcon} className="manage-profile" alt="group number" /><span className="hover-tooltip group-number">Group Number</span></a>
                                                                                            <a href="javascript:void('0')" className="custom-tooltip"><img onClick={this.manageEmail} whsearch={this.state.whSearchText} currentpagination={this.state.currentPaging} datawhid={e1.whId} data-id={e1.dashBoardId} data-name={e1.whName} src={emailIcon} className="manage-emails" alt="Manage Emails" /><span className="hover-tooltip manage-email">Manage Emails</span></a>
                                                                                            <a href="javascript:void('0')" className="custom-tooltip"><img onClick={this.editProfile} whsearch={this.state.whSearchText} datawhprefix={e1.gnfix} currentpagination={this.state.currentPaging} data-comm={e1.whComm} data-id={e1.whId} data-name={e1.whName} src={profileIcon} className="profile-icon" alt="Manage Profile & Rules" /><span className="hover-tooltip manage-profile">Manage Profile & Rules</span></a>
                                                                                        </div>
                                                                                }
                                                                            </td>
                                                                        </tr>)
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                    :
                                                    <div>
                                                        {
                                                            this.state.loader ?
                                                                <div className="please-wait"><h3>Please wait...</h3></div> :
                                                                <div className="please-wait color-red"><h3>{this.state.Data_Not_Found}</h3></div>
                                                        }
                                                    </div>

                                            }
                                            {
                                                this.state.UserList != null && this.state.UserList.length > 0 ?
                                                    <Pagination
                                                        activePage={this.state.activePage}
                                                        itemsCountPerPage={9}
                                                        totalItemsCount={this.state.UserList.length}
                                                        pageRangeDisplayed={5}
                                                        onChange={this.handlePageChange.bind(this)}
                                                    /> : null
                                            }
                                            {error &&
                                                <div className={'alert alert-danger delete'}>{error}</div>
                                            }

                                        </div>
                                    </div>
                                    :
                                    <div className="Inactive-content">
                                        <div className="content-section">

                                            {
                                                this.state.TerminatedList != null && this.state.TerminatedList.length > 0 ?
                                                    <table>
                                                        <thead>
                                                            <tr className="header">
                                                                <th className="first-one">Name</th>
                                                                <th className="second-one">No. of Group Number</th>
                                                                <th className="third-one">Group Prefix</th>
                                                                <th className="fourth-one">Termination Date</th>
                                                                <th className="fifth-one">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id="inactive_reps">
                                                            {
                                                                this.state.TerminatedList_Temp.map((e1, i1) => {
                                                                    return (
                                                                        <tr className="userDashData" key={i1}>
                                                                            <td className="first-one">
                                                                                {e1.whName}
                                                                            </td>
                                                                            <td className="second-one">
                                                                                {e1.groupCount}
                                                                            </td>
                                                                            <td className="third-one">
                                                                                {e1.gnfix}
                                                                            </td>
                                                                            <td className="fourth-one">
                                                                                {e1.terminationDate}
                                                                            </td>
                                                                            <td className="fifth-one bar">
                                                                                <div>
                                                                                    <a href="javascript:void('0')" className="custom-tooltip"><img src={exportIcon} className="manage-profile export_icon" alt="group number" data-id={e1.whId} data-name={e1.whName} onClick={this.ExportGroupNumberData} /><span className="hover-tooltip group-number">Download Group Numbers</span></a>
                                                                                    <a href="javascript:void('0')" className="custom-tooltip distributor-data"><img src={exportIcon} className="create-dashboard export_icon" alt="Create Dashboard" data-id={e1.whId} data-name={e1.whName} onClick={this.ExportDistributorData} /><span className="hover-tooltip create-dashboard">Download Distributor Data</span></a>
                                                                                </div>
                                                                            </td>
                                                                        </tr>)
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                    :
                                                    <div>
                                                        {
                                                            this.state.loader ?
                                                                <div className="please-wait"><h3>Please wait...</h3></div> :
                                                                <div className="please-wait color-red"><h3>{this.state.Data_Not_Found}</h3></div>
                                                        }
                                                    </div>

                                            }
                                            {
                                                this.state.TerminatedList != null && this.state.TerminatedList.length > 0 ?
                                                    <Pagination
                                                        activePage={this.state.activePage}
                                                        itemsCountPerPage={9}
                                                        totalItemsCount={this.state.TerminatedList.length}
                                                        pageRangeDisplayed={5}
                                                        onChange={this.terminatedPageChange.bind(this)}
                                                    /> : null
                                            }
                                            {error &&
                                                <div className={'alert alert-danger delete'}>{error}</div>
                                            }

                                        </div>
                                    </div>
                            }
                        </div>



                    </div>
                </div>
            </div>
        );
    }
}


export default Popup;